/**
 * Main application entry point.
 */

'use strict';

var app           = require('stb-app'),
    tools         = require('./modules/tools'),
    messagesToApp = require('../../../plugin-browser/src/js/messages').toApp;


stbEvent.trigger      = tools.trigger;
stbEvent.bind         = tools.bind;
app.activePage        = {};
app.activePage.events = {};

gSTB.EnableVKButton(true);
gSTB.EnableAppButton(false);
gSTB.EnableServiceButton(false);

app.once('load', function () {
    var parse  = require('cjs-uri').parse,
        params = parse(location.href).queryKey,
        core   = require('./modules/core'),
        keys   = require('stb-keys'),
        config = app.config;

    config.portalWindowId = params.portalWindowId || config.portalWindowId;
    params.page && (core.resourcesLoadState.browseIntent = true);
    core.loadUrl(params.page || config.startPage);

    app.addListener('keydown', function ( event ) {
        switch ( event.code ) {
            case keys.f1:
                core.actions.f1();
                break;
            case keys.f2:
                core.actions.f2();
                break;
            case keys.f3:
                core.actions.f3();
                break;
            case keys.f4:
                core.actions.f4();
                break;
            case keys.menu:
                core.mode = core.MODE_MENU;
                stbWindowMgr.windowHide(core.webWindowHandle);
                stbWebWindow.messageSend(config.portalWindowId, messagesToApp.openMenu);
                break;
            case keys.frame:
                core.actions.frame();
                break;
            case keys.back:
                gSTB.CloseWebWindow();
                stbWebWindow.messageSend(config.portalWindowId, messagesToApp.back);
                break;
            case keys.exit:
                // add for preventing loading possibly heavy pages in background
                if ( core.resourcesLoadState.isLoadStartTriggered ) {
                    core.actions.stop();
                }
                stbWindowMgr.windowHide(core.webWindowHandle);
                stbWebWindow.messageSend(config.portalWindowId, messagesToApp.home);
                break;
            case keys.mute:
                break;
            case keys.app:
                core.mode = core.MODE_MENU;
                stbWindowMgr.windowHide(core.webWindowHandle);
                stbWebWindow.messageSend(config.portalWindowId, messagesToApp.openTaskManager);
                break;
            case keys.set:
                core.mode = core.MODE_MENU;
                stbWindowMgr.windowHide(core.webWindowHandle);
                stbWebWindow.messageSend(config.portalWindowId, messagesToApp.openSettings);
                break;
        }
    });
});
